import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import { Tooltip } from "antd";
import XtLoading from "@/components/Xt/Loading";
import NoData from "components/App/div/noData";
import CurrencySelect from "components/Pages/Finance/_cmpt/CurrencySelect";
// import DropProducts from "@/components/Pages/Finance/Drop/Products";
// import DropDuration from "@/components/Pages/Finance/Drop/Duration";
import DropSelect from "@/components/Pages/Finance/Drop/Select";
import TableRow from "./TableRow";
import cx from "classnames";
import styles from "./index.module.less";
import stylesProducts from "@/components/Pages/Finance/Styles/products.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import { get_product } from "api/v4/finance";
import XtSvg from "@/components/Xt/Svg";
import useSortByApy from "@/components/Pages/Finance/_hook/useSortByApy";

export default observer(() => {
  const t = useTranslation();
  const { app, finance } = useStore();

  const limit = 8;
  const fromPage = useRef(1);

  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState([]);

  // const [filterDuration, setFilterDuration] = useState("ALL");
  const [filterSelect, setFilterSelect] = useState([]);
  const [currency, setCurrency] = useState();

  const isAvailable = useMemo(() => filterSelect.includes("displayAvailableOnly"), [filterSelect]);
  const isMatchMyAssets = useMemo(() => filterSelect.includes("matchMyAssets"), [filterSelect]);
  const isSortByApy = useMemo(() => filterSelect.includes("sortByApy"), [filterSelect]);

  const [hasMore, setHasMore] = useState(false);

  const apiReq = useCallback(
    (isMore) => {
      if (loading) return;
      setLoading(true);
      if (!isMore) fromPage.current = 1;

      get_product({
        params: {
          categories: "STAKING",
          financeProductType: "POS_STAKING",
          available: filterSelect.includes("displayAvailableOnly") ? true : undefined,
          matchMyAssets: filterSelect.includes("matchMyAssets") ? true : undefined,
          // sortByApy: filterSelect.includes("sortByApy") ? true : undefined,
          currency,
          limit: -1,
          fromPage: fromPage.current + (isMore ? 1 : 0),
        },
        errorPop: true,
      })
        .then((result) => {
          /*
          result = {
            hasPrev: false,
            hasNext: false,
            items: [
              {
                groupTag: "btc",
                productCollections: [
                  {
                    category: "SAVING",
                    financialProducts: [
                      {
                        id: 1,
                        tenantId: 1,
                        productType: "FLEXIBLE",
                        currencyId: 2,
                        currency: "BTC",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "NORMAL",
                        apyList: [
                          {
                            level: 1.2,
                            annualized: 10.3,
                          },
                        ],
                        systemTag: "HOT",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: null,
                        interestCurrencyId: 2,
                        interestCurrency: "BTC",
                        totalReward: 0,
                        rewardPercent: 0,
                        officialSite: "string",
                        whitePaperSite: "string",
                        regulationSite: "string",
                        enableRedemption: true,
                        groupId: 0,
                        productNames: [
                          {
                            language: "en",
                            name: "btc-flexible",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: true,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: true,
                        weight: 10,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                      {
                        id: 2,
                        tenantId: 1,
                        productType: "FLEXIBLE",
                        currencyId: 2,
                        currency: "BTC",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "NORMAL",
                        apyList: [
                          {
                            level: 1.2,
                            annualized: 10.3,
                          },
                        ],
                        systemTag: "HOT",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: null,
                        interestCurrencyId: 2,
                        interestCurrency: "BTC",
                        totalReward: 0,
                        rewardPercent: 0,
                        officialSite: "string",
                        whitePaperSite: "string",
                        regulationSite: "string",
                        enableRedemption: true,
                        groupId: 0,
                        productNames: [
                          {
                            language: "en",
                            name: "btc-flexible",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: true,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: 10,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                      {
                        id: 6,
                        tenantId: 1,
                        productType: "PROMOTIONS",
                        currencyId: 2,
                        currency: "BTC",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "GRADING",
                        apyList: [
                          {
                            level: 1.1,
                            annualized: 8.3,
                          },
                          {
                            level: 2.1,
                            annualized: 9.3,
                          },
                        ],
                        systemTag: "NEW",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: "WARMING",
                        interestCurrencyId: 11,
                        interestCurrency: "USDT",
                        totalReward: 600,
                        rewardPercent: 21.1,
                        officialSite: "abc",
                        whitePaperSite: "abc",
                        regulationSite: "abc",
                        enableRedemption: false,
                        groupId: 121,
                        productNames: [
                          {
                            language: "en",
                            name: "eth-fix",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: false,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: null,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                    ],
                  },
                  {
                    category: "STAKING",
                    financialProducts: [
                      {
                        id: 3,
                        tenantId: 1,
                        productType: "FIX",
                        currencyId: 5,
                        currency: "ETH",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "GRADING",
                        apyList: [
                          {
                            level: 1.1,
                            annualized: 8.3,
                          },
                          {
                            level: 2.1,
                            annualized: 9.3,
                          },
                        ],
                        systemTag: "NEW",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: null,
                        interestCurrencyId: 11,
                        interestCurrency: "USDT",
                        totalReward: 0,
                        rewardPercent: 0,
                        officialSite: "string",
                        whitePaperSite: "string",
                        regulationSite: "string",
                        enableRedemption: true,
                        groupId: 0,
                        productNames: [
                          {
                            language: "en",
                            name: "eth-fix",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: true,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "STAKING",
                        recommended: false,
                        weight: null,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                      {
                        id: 4,
                        tenantId: 1,
                        productType: "PROMOTIONS",
                        currencyId: 5,
                        currency: "ETH",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "GRADING",
                        apyList: [
                          {
                            level: 1.1,
                            annualized: 8.3,
                          },
                          {
                            level: 2.1,
                            annualized: 9.3,
                          },
                        ],
                        systemTag: "NEW",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: "WARMING",
                        interestCurrencyId: 11,
                        interestCurrency: "USDT",
                        totalReward: 0,
                        rewardPercent: 0,
                        officialSite: "string",
                        whitePaperSite: "string",
                        regulationSite: "string",
                        enableRedemption: true,
                        groupId: 0,
                        productNames: [
                          {
                            language: "en",
                            name: "eth-fix",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: true,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: null,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                      {
                        id: 5,
                        tenantId: 1,
                        productType: "PROMOTIONS",
                        currencyId: 5,
                        currency: "ETH",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "GRADING",
                        apyList: [
                          {
                            level: 1.1,
                            annualized: 8.3,
                          },
                          {
                            level: 2.1,
                            annualized: 9.3,
                          },
                        ],
                        systemTag: "NEW",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: "WARMING",
                        interestCurrencyId: 11,
                        interestCurrency: "USDT",
                        totalReward: 600,
                        rewardPercent: 21.1,
                        officialSite: "abc",
                        whitePaperSite: "abc",
                        regulationSite: "abc",
                        enableRedemption: false,
                        groupId: 121,
                        productNames: [
                          {
                            language: "en",
                            name: "eth-fix",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: false,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: null,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                    ],
                  },
                ],
              },
              {
                groupTag: "eth",
                productCollections: [
                  {
                    category: "SAVING",
                    financialProducts: [
                      {
                        id: 3,
                        tenantId: 1,
                        productType: "FIX",
                        currencyId: 5,
                        currency: "ETH",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "GRADING",
                        apyList: [
                          {
                            level: 1.1,
                            annualized: 8.3,
                          },
                          {
                            level: 2.1,
                            annualized: 9.3,
                          },
                        ],
                        systemTag: "NEW",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: null,
                        interestCurrencyId: 11,
                        interestCurrency: "USDT",
                        totalReward: 0,
                        rewardPercent: 0,
                        officialSite: "string",
                        whitePaperSite: "string",
                        regulationSite: "string",
                        enableRedemption: true,
                        groupId: 0,
                        productNames: [
                          {
                            language: "en",
                            name: "eth-fix",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: true,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: null,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                      {
                        id: 4,
                        tenantId: 1,
                        productType: "PROMOTIONS",
                        currencyId: 5,
                        currency: "ETH",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "GRADING",
                        apyList: [
                          {
                            level: 1.1,
                            annualized: 8.3,
                          },
                          {
                            level: 2.1,
                            annualized: 9.3,
                          },
                        ],
                        systemTag: "NEW",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: "WARMING",
                        interestCurrencyId: 11,
                        interestCurrency: "USDT",
                        totalReward: 0,
                        rewardPercent: 0,
                        officialSite: "string",
                        whitePaperSite: "string",
                        regulationSite: "string",
                        enableRedemption: true,
                        groupId: 0,
                        productNames: [
                          {
                            language: "en",
                            name: "eth-fix",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: true,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: null,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                      {
                        id: 5,
                        tenantId: 1,
                        productType: "PROMOTIONS",
                        currencyId: 5,
                        currency: "ETH",
                        currencyPrecision: 10,
                        totalQuota: 1000,
                        individualCap: 3,
                        singleMin: 0.01,
                        singleMax: 1,
                        profitType: "GRADING",
                        apyList: [
                          {
                            level: 1.1,
                            annualized: 8.3,
                          },
                          {
                            level: 2.1,
                            annualized: 9.3,
                          },
                        ],
                        systemTag: "NEW",
                        available: true,
                        autoEnable: false,
                        duration: 100,
                        noviceExclusive: false,
                        subscribeStartTime: 1695613309126,
                        subscribeEndTime: 1698205330791,
                        workStartTime: 1699933356625,
                        financeProductStatus: "WARMING",
                        interestCurrencyId: 11,
                        interestCurrency: "USDT",
                        totalReward: 600,
                        rewardPercent: 21.1,
                        officialSite: "abc",
                        whitePaperSite: "abc",
                        regulationSite: "abc",
                        enableRedemption: false,
                        groupId: 121,
                        productNames: [
                          {
                            language: "en",
                            name: "eth-fix",
                          },
                        ],
                        productPrice: 0,
                        enableStaking: false,
                        stakingPercent: 0,
                        hashRatePerShare: 0,
                        hashRateUnit: "string",
                        managementFee: 0,
                        dailyMinOutput: 0,
                        dailyMaxOutput: 0,
                        dailyActualOutput: 0,
                        stakingCurrencyId: 0,
                        stakingCurrency: "string",
                        category: "SAVING",
                        recommended: false,
                        weight: null,
                        customTags: [
                          {
                            language: "en",
                            name: "all-in",
                          },
                        ],
                        creator: "alex",
                        createdTime: 1693885510021,
                        updater: null,
                        updatedTime: 1693885510021,
                        subscribed: null,
                        workEndTime: 1708573356625,
                      },
                    ],
                  },
                ],
              },
            ],
          };
          */

          setResData(isMore ? [...resData, ...result.items] : result.items || []);
          setHasMore(result.hasNext);
          isMore && (fromPage.current = fromPage.current + 1);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [resData, loading, isAvailable, isMatchMyAssets, currency]
  );

  useEffect(() => {
    apiReq();
  }, [isAvailable, isMatchMyAssets, currency]);

  const onViewMore = useCallback(() => {
    apiReq(true);
  }, [apiReq]);

  const [isExpand, setIsExpand] = useState(false);
  const isMoreBtn = useMemo(() => resData.length > limit, [resData]);
  const onMoreBtnClick = useCallback(() => setIsExpand(!isExpand), [isExpand]);

  const resDataSort = useSortByApy(resData, isSortByApy);
  const items = useMemo(() => resDataSort.slice(0, isExpand ? undefined : limit), [resDataSort, isExpand]);

  const [timestamp, setTimestamp] = useState("");
  useEffect(() => {
    setTimestamp(Date.now());
  }, [resDataSort]);

  return (
    <div className={styles.main}>
      <h2 className={stylesProducts.title}>{t("finance.PoSStaking")}</h2>
      <div className={stylesProducts.content}>
        <div className={stylesProducts.filterCon}>
          <div>
            <DropSelect data={filterSelect} callback={setFilterSelect} />
          </div>
          <div>
            <CurrencySelect className={stylesProducts.search} value={currency} onChange={setCurrency} />
          </div>
        </div>

        <div className={stylesProducts.bodyCon}>
          {!app.isH5 && (
            <div className={cx(stylesProducts.tableNav, styles.tableRowLayout)}>
              <div>{t("finance.coin")}</div>
              <div>{t("finance.apy")}</div>
              <div>{t("finance.durationDays")}</div>
              <div>{t("console.operate")}</div>
            </div>
          )}

          <div className={stylesProducts.tableCon}>
            {!items.length ? (
              <NoData className={stylesProducts.noData} />
            ) : (
              <>
                {items.map((data) => (
                  <TableRow key={data.groupTag + "-" + timestamp} data={data} rowCls={styles.tableRowLayout} />
                ))}

                {isMoreBtn && (
                  <div className={stylesProducts.more}>
                    <button className={cx("btnTxt")} onClick={onMoreBtnClick}>
                      <span>{isExpand ? t("finance.collapse") : t("cmpt.viewmore")}</span>
                      <XtSvg icon={"doubleArrow"} style={{ marginLeft: "5px", transform: isExpand ? "rotateZ(-90deg)" : "rotateZ(90deg)" }} />
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {loading && <XtLoading />}
      </div>
    </div>
  );
});
